import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Tooltip from '../../CommonComponents/Tooltip';
import ReactHighcharts from '../../CommonComponents/Highcharts';
import LoadingChart from '../../CommonComponents/LoadingChart';
import { getGoalsChartList } from '../../DebtManagementChart/DebtManagementChartActions';
import * as healthCareSelector from '../../DebtManagementChart/DebtManagementChartSelector';

const DebtManagementGoalChart = props => {
  const { clientId, fpId, goalId, initialChartData, isCurrentPlan, proposedPlan, title } = props;
  const dispatch = useDispatch();

  const chartData = useSelector(state => healthCareSelector.goalChartPopulated(state, props));
  const hasLoaded = useSelector(state => healthCareSelector.hasLoaded(state, props));

  useEffect(() => {
    if (!initialChartData) {
      dispatch(getGoalsChartList(fpId, clientId, false, goalId));
    }
  }, [fpId]);

  return (
    <div>
      <h4>{title}</h4>

      <ul className="legend hide-on-mobile-screens">
        {!isCurrentPlan && (
          <Tooltip
            tag="li"
            tooltipchildren={ADV.tooltip_callouts.DebtManagementChart.Current.html}
            orientation={ADV.tooltip_callouts.DebtManagementChart.Current.orientation}
          >
            <i />
            Current
          </Tooltip>
        )}
        {!isCurrentPlan && (
          <Tooltip
            tag="li"
            className="proposed-plan"
            tooltipchildren={ADV.tooltip_callouts.DebtManagementChart.ProposedPlanOverview.html}
            orientation={ADV.tooltip_callouts.DebtManagementChart.ProposedPlanOverview.orientation}
          >
            <i className="debt-management-proposed" />
            {proposedPlan}
          </Tooltip>
        )}
      </ul>

      {!hasLoaded && <LoadingChart />}

      {hasLoaded && (
        <section className="NewFinancialPlan_DebtManagementProgressChart">
          <ReactHighcharts
            autoResize
            className="debtManagement-chart-container"
            container="DebtManagementChart"
            options={chartData}
          />
        </section>
      )}
    </div>
  );
};

DebtManagementGoalChart.defaultProps = {
  initialChartData: null,
};

DebtManagementGoalChart.propTypes = {
  clientId: PropTypes.string.isRequired,
  proposedPlan: PropTypes.string.isRequired,
  fpId: PropTypes.string.isRequired,
  goalId: PropTypes.string.isRequired,
  initialChartData: PropTypes.shape({}),
  isCurrentPlan: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default DebtManagementGoalChart;
